import api, { adminApiPrefix, apiPrefix } from './Api';
import {
  Gallery,
  galleryFromResponse,
  galleryToUpsertRequest,
} from '../interfaces/Gallery/Gallery';
import { Pagination, paginationToParams } from '../interfaces/Pagination';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import { GalleryMediaOptions } from '../interfaces/Gallery/GalleryMediaOptions';

const galleryAdminApiPrefix = `${adminApiPrefix}/galleries`;
const galleryApiPrefix = `${apiPrefix}/galleries`;

export const createGallery = async (gallery: Gallery): Promise<Gallery> => {
  const response = await api.post(
    `${galleryAdminApiPrefix}/`,
    galleryToUpsertRequest(gallery),
  );

  return galleryFromResponse(response.data?.data);
};

export const getGalleries = async (
  pagination: Pagination,
): Promise<PaginatedResponse<Gallery>> => {
  const response = await api.get(galleryApiPrefix, {
    params: paginationToParams(pagination),
  });

  return {
    data: (response.data?.data ?? []).map((gallery: any) =>
      galleryFromResponse(gallery),
    ),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const getGallery = async (id: number): Promise<Gallery> => {
  const response = await api.get(`${galleryApiPrefix}/${id}`);

  return galleryFromResponse(response.data?.data);
};

export const updateGallery = async (gallery: Gallery): Promise<Gallery> => {
  const response = await api.put(
    `${galleryAdminApiPrefix}/${gallery.id}`,
    galleryToUpsertRequest(gallery),
  );

  return galleryFromResponse(response.data?.data);
};

export const updateGalleryMedia = async (
  id: number,
  options: GalleryMediaOptions,
): Promise<Gallery> => {
  const bodyFormData = new FormData();

  if (options.image) {
    bodyFormData.append('image', options.image);
  }

  if (options.eraseImage) {
    bodyFormData.append('erase-image', '1');
  }

  const response = await api.put(
    `${galleryAdminApiPrefix}/media/${id}`,
    bodyFormData,
  );

  return galleryFromResponse(response.data?.data);
};

export const deleteGallery = async (id: number): Promise<void> =>
  api.delete(`${galleryAdminApiPrefix}/${id}`);
